import React, { useEffect }                        from 'react';
import PropTypes                    from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import Parameters        from './Parameters';
import PriceCombined     from './PriceCombined';
import Loading           from './Loading';
import Info              from './Info';
import ParametersSummary from './ParametersSummary';
import BundleItemWrap    from '../../shared/pu-react/components/BundleItemWrap';
import BundleItemTabWrap from 'pu-react/components/BundleItemTabWrap';
import PriceVendor       from './PriceVendor';
import PriceChina        from './PriceChina';
import PriceTaiwan       from './PriceTaiwan'

import {
  allowEdit,
  changeParameter,
  deleteQuote,
  fetchQuote,
  priceSelected,
}                from '../data/FabricationSlice'
import { changeParameter as assemblyChangeParameter } from '../../pcb-assembly/data/AssemblySlice'

import { START } from '../../shared/pu-data/QuoteSteps';

const Subtitle = () => (
  <React.Fragment>
    To get an online PCB Fabrication quote simply fill out the following form
    and click on the GET A QUOTE button.
    <br />
    Our system will automatically display two quotes, one for boards fabricated
    in the USA and one for boards made in China.
    <br />
    During the checkout process you determine if the bare boards will ship
    directly
    to you or to out PCB Assembly facility in Oregon.
    <br />
    The transit time for offshore PCBs (e.i China to the USA) is usually 2
    business
    days.
  </React.Fragment>
)

const Fabrication = ({ itemId }) => {
  const dispatch = useDispatch()

  const {
    name,
    // code,
    quote,
    loading,
    showSummary,
    itemSelected,
    // boardConfirmSpecs,
    suppliers,
    variantId,
    sameBasicParams,

    parametersChanged,
    parameters,
    parametersBestPrice,
    parametersCustomer,
    parametersOffshore,

    // usGroups,
    // usCombined,
    quoteStep,
    errors,
    firstQuoteMade
  } = useSelector((state) => state.fabrication)
  const assemblyQuote = useSelector((state) => state.assembly).quote

  const onRequestQuote = () => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(fetchQuote(
      suppliers,
      { parametersCustomer, parametersBestPrice, parametersOffshore },
      sameBasicParams,
      authToken,
      itemId,
    ))
  }

  const onChangeParameter = (prmName, value) => {
    dispatch(changeParameter({ name: prmName, value }))
  }

  const onPriceSelect = (data) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(priceSelected(data, authToken, parametersCustomer.product_quote_number))
  }

  useEffect(() => {
    // Sync quantities with pcb assembly quote
    if (!assemblyQuote.number && parameters.product_quote_number) {
      dispatch(assemblyChangeParameter({name: 'quantities', value: parametersCustomer.quantities}))
    }
  }, [parameters.product_quote_number])

  const showEdit = quoteStep !== START && showSummary
  const showDelete = quoteStep !== START && (!!quote || !!quote.line_items)

  return (
    <BundleItemTabWrap
      name={name}
      subtitle={<Subtitle />}
      showAnimationHeight={true}
      showEdit={showEdit}
      showDelete={showDelete}
      showSummary={showSummary}
      onEdit={() => dispatch(allowEdit())}
      onDelete={() => dispatch(deleteQuote())}
      contentClassName={{ summary: showSummary }}>
      <div className="pcb-fabrication-section">
        <Loading loading={loading} />
        <div className="form-content">
          <div className="row">
            <div className="col-lg-5">
              <Parameters
                itemId={itemId}
                parameters={parameters}
                itemSelected={itemSelected}
                parametersCustomer={parametersCustomer}
                parametersBestPrice={parametersBestPrice}
                parametersOffshore={parametersOffshore}
                onChangeParameter={onChangeParameter}
                onRequestQuote={onRequestQuote}
                showSummary={false}
                errors={errors}
                variantId={variantId} />
              <div className="summary-section">
                <ParametersSummary
                  showSummary={false}
                  parameters={parametersCustomer} />
              </div>
            </div>
            <div className="col-lg-7 ">
              <div className="pcb-price-section">
                <PriceCombined
                  parameters={parameters}
                  parametersChanged={parametersChanged}
                  parametersBestPrice={parametersBestPrice}
                  quote={quote}
                  quoteStep={quoteStep}
                  onPriceSelect={onPriceSelect}
                  showSummary={false} />
                <PriceVendor
                  quoteStep={quoteStep}
                  quote={quote}
                  showSummary={false} />
                <hr />
                <PriceTaiwan
                  parameters={parameters}
                  parametersCustomer={parametersCustomer}
                  parametersChanged={parametersChanged}
                  quote={quote}
                  onPriceSelect={onPriceSelect}
                  showSummary={false}
                  rowSelected={parameters.row_selected} />
                <hr />
                <PriceChina
                  parameters={parameters}
                  parametersCustomer={parametersCustomer}
                  parametersChanged={parametersChanged}
                  quote={quote}
                  onPriceSelect={onPriceSelect}
                  showSummary={false}
                  rowSelected={parameters.row_selected} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BundleItemTabWrap>
  );
};

Fabrication.propTypes = {
  itemId: PropTypes.number.isRequired,
}

export default Fabrication
